import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { AppContext } from '../Context/AppContextProvide';
import { useContext, useEffect } from 'react';
import { Backdrop, Typography } from '@material-ui/core';

export default function Root() {
  const { isLoggedOut } = useContext(AppContext);
  const history = useHistory();

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!isLoggedOut) {
        history.push("/home");
        return;
      }

      history.push("/signin");
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  return ( 
    <>
      <Backdrop open={true} style={{color: "#28C4FC", backgroundColor: "#142E3E"}}>
        <div style={{textAlign: "center"}}>
          <Typography variant="h3" style={{color: "#28C4FC"}}>Welcome to Showroom Pricing!</Typography>
        </div>
      </Backdrop>
    </> 
  );
};
